import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SisterShipPopupComponent } from './sister-ship-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SisterShipPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  exports:[
    SisterShipPopupComponent
  ]
})
export class SisterShipPopupModule { }
